import { PixelStreaming, WebRtcPlayerController } from "@epicgames-ps/lib-pixelstreamingfrontend-ue5.5";
import { ArcwarePixelStreaming } from "./ArcwarePixelStreaming";

export function UrlBuilder(input: () => string, urlFlags?: string) {
  const url = new URL(decodeURIComponent(input()));
  const params = url.searchParams;

  let flags = urlFlags;
  if (flags) {
    if (flags.startsWith("?")) flags = flags.substring(1);
    flags.split("&").forEach((val) => {
      const [key, value] = val.split("=");
      // Ensure the value is encoded
      params.append(key, value);
    });
  }

  return url.toString();
}

// Hack
export function ApplyUrlHack() {
  const setWebRtcPlayerController = PixelStreaming.prototype["setWebRtcPlayerController"];
  PixelStreaming.prototype["setWebRtcPlayerController"] = function setWebRtcPlayerControllerOverride(
    this: ArcwarePixelStreaming,
    webRtcPlayerController: WebRtcPlayerController
  ): void {
    /** The default url builder will simply add a query-parameter without checking the initial url.
     * To fix that if the url already comes with query-parameters the output has to be rewritten. */
    const signallingUrlBuilder = webRtcPlayerController.signallingUrlBuilder;
    webRtcPlayerController.signallingUrlBuilder = () => {
      return UrlBuilder(signallingUrlBuilder, this.config.urlFlags);
    };

    setWebRtcPlayerController.call(this, webRtcPlayerController);
  };
}
